import { createSlice } from "@reduxjs/toolkit";
import toolbarConfiguration from "../components/Toolbar/toolbarConfig";

const {
  category,
  sku,
  DC,
  supplier,
  risk_type,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
} = toolbarConfiguration.filterMap;

const wfStrategicSummarySlice = createSlice({
  name: "wfStrategicSummary",
  initialState: {
    apiLoading: {
      kpi: false,
      trendArea: false,
    },
    filters: {
      [category.filterId]: [],
      [sku.filterId]: [],
      [supplier.filterId]: [],
      [DC.filterId]: [],
      [tier2_suppliers.filterId]: [],
      [tier2_skus.filterId]: [],
      [risk_type.filterId]: [],
      [supplier_org.filterId]: [],
      [assembly_item.filterId]: [],
      country: [],
    },
    strategicRiskKPIData: {},
    trendAreaData: [],
    resetTriggered: false,
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setFilters(state, action) {
      const { filters, filterId } = action.payload;
      const currentFilters = state.filters;

      if (filterId && filterId !== "status") {
        delete filters[filterId];
      }

      state.filters = {
        ...currentFilters,
        ...filters,
      };
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
    setStrategicRiskKPIData(state, action) {
      state.strategicRiskKPIData = action.payload;
    },
    setTrendAreaData(state, action) {
      state.trendAreaData = action.payload;
    },
  },
});

export const {
  setLoader,
  setResetTriggered,
  setFilters,
  setStrategicRiskKPIData,
  setTrendAreaData,
} = wfStrategicSummarySlice.actions;

export default wfStrategicSummarySlice.reducer;
